import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, axios, formatApiErrorDetail } from "../utils/api";
import { Wordmark } from "../components/marketing/Wordmark";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/login`, { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-paper font-plex flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-black/20 bg-white p-10">
        <Wordmark size="text-3xl" />
        <h1 className="mt-4 text-lg font-semibold text-black">Admin Dashboard</h1>
        <p className="mt-1 text-sm text-black/50">PT Darma Daya Guna — restricted area</p>

        <form onSubmit={handleLogin} className="mt-8 flex flex-col gap-4" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-semibold tracking-wider uppercase text-black/50 mb-2">
              Email
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-black/25 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-green rounded-none"
              autoComplete="username"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-semibold tracking-wider uppercase text-black/50 mb-2">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-black/25 px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-green rounded-none"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="text-sm text-brand-red font-medium" role="alert">
              {error}
            </p>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="mt-2 bg-brand-ink text-brand-paper py-3.5 text-sm font-semibold tracking-wide hover:bg-brand-green disabled:opacity-50 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-brand-green"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <a href="/" data-testid="back-to-site-link" className="mt-6 inline-block text-xs text-black/40 hover:text-black transition-colors">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
